import React from 'react';
import Loader01 from "../images/loader/loader01.png"
import Loader02 from "../images/loader/loader02.png"
import Loader03 from "../images/loader/loader03.png"
import Loader04 from "../images/loader/loader04.png"
import Loader05 from "../images/loader/loader05.png"
import Loader06 from "../images/loader/loader06.png"
import Loader07 from "../images/loader/loader07.png"
import Loader08 from "../images/loader/loader08.png"
import Loader09 from "../images/loader/loader09.png"
import Loader10 from "../images/loader/loader10.png"
import Loader11 from "../images/loader/loader11.png"
import Loader12 from "../images/loader/loader12.png"

export default class Loader extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			index: 0
		}
	}

	loaderList = [
		Loader01,
		Loader02,
		Loader03,
		Loader04,
		Loader05,
		Loader06,
		Loader07,
		Loader08,
		Loader09,
		Loader10,
		Loader11,
		Loader12
	]

	componentWillMount() {
		setInterval(() => {
			this.setState({ index: (this.state.index + 1 >= this.loaderList.length) ? 0 : this.state.index + 1 })
		}, 50)
	}

	renderImages = () => {
		return this.loaderList.map((o, key) => (
			<img src={o} alt="info" className={"Image"} style={{ width: (this.state.index === key) ? 150 : 0 }} key={key}/>
		))
	}

	render() {
		return (
			<div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
				<div>
					{this.renderImages()}
					<div style={{ display: "flex", width: 100, fontSize: 14, paddingLeft: 40 }}>
						<div>Chargement </div>
						<div style={{ paddingLeft: 5 }}>{ this.state.index < this.loaderList.length / 3 ? '.' : ((this.state.index < this.loaderList.length / 3 * 2) ? '..' : '...') }</div>
					</div>
				</div>
			</div>
		)
	}
}